import React, { useState } from 'react';
import classNames from 'classnames';
import UIButton from 'Components/UIComponents/UIButton';
import { useIsMobile } from 'Hooks/Common';
import { discountPlanPrices, PlanDurations, PlanTypes } from 'Interfaces/Billing';
import { Document } from 'Interfaces/Document';

import { LandingSignUpForm } from './components';

interface LandingSignUpProps {
  document?: Document;
}

export const LandingSignUp = ({ document }: LandingSignUpProps) => {
  const isMobile = useIsMobile();
  const [isFormStep, setIsFormStep] = useState(false);

  return (
    <div className={classNames('sign-up-landing__signUp-form', { mobile: isMobile })}>
      {!isFormStep ? (
        <div
          className={classNames('sign-up-landing__signUp-info-container', {
            mobile: isMobile,
          })}
        >
          <p className="sign-up-landing__signUp-info-header">Get started</p>
          <p className="sign-up-landing__signUp-info-text">
            Please add your payment details to start the free trial, the signed document
            will be available once you sign up. You can cancel anytime before the free
            trial ends to avoid being billed.
          </p>
          <div className={classNames('sign-up-landing__signUp-plan-container')}>
            <div className={'sign-up-landing__signUp-plan-item'}>
              <div className="sign-up-landing__signUp-plan-label">
                <div className="sign-up-landing__signUp-plan-subscription--name">
                  Business Monthly
                </div>
                <div className="sign-up-landing__signUp-plan-subscription--price">
                  $0 due Today
                </div>
              </div>
              <div className="sign-up-landing__signUp-plan-subscription--price">
                ${discountPlanPrices[PlanTypes.BUSINESS][PlanDurations.MONTHLY]}/month
                after your trial
              </div>
              <div className="sign-up-landing__signUp-plan-subscription--price">
                A temporary $1-$5 authorization hold may appear to verify your card and
                account. It is released immediately after verification and is not your
                subscription charge.
              </div>
            </div>
          </div>
          <div className="sign-up-landing__signUp-info-action">
            <UIButton
              priority="primary"
              title="Continue"
              handleClick={() => setIsFormStep(true)}
              className="centered-text sign-up-second-step__button"
            />
          </div>
        </div>
      ) : (
        <div className="sign-up-landing__signUp-content-container">
          <LandingSignUpForm
            document={document}
            fieldClassName="sign-up-second-step__field container"
          />
        </div>
      )}
    </div>
  );
};

export default LandingSignUp;
